import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isInternal, setIsInternal] = useState(false);
    const [user, setUser] = useState({});

    const serverHost = process.env.REACT_APP_BACKEND_SERVER_HOST || 'https://localhost:3001';

    const login = (user) => {
        setIsLoggedIn(true);
        setIsAdmin(user.role === 'admin');
        setIsInternal(user.role === 'internal');
        setUser(user);
    };

    const logout = async () => {
        setIsLoggedIn(false);
        setIsAdmin(false);
        setIsInternal(false);
        setUser({});
        await axios.post(`${serverHost}/logout`, {}, { withCredentials: true });
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, isAdmin, isInternal, user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
